/* jshint undef: true, unused: true */
/* globals require */

var FoBuComponentFactory = require('./fobu-component-factory');

function createRadioOrCheckboxLabel (elementId, labelText, foBu) {

  var label = document.createElement('label');

  foBu.addAttributes(label, {'for': elementId});
  label.classList.add('form__label');

  label.innerHTML = labelText;
  return label;
}

function addRadioOrCheckboxOptions (parentElement, componentSettings, selectedOption, foBu) {
  var i       = 0,
      options = componentSettings.options;

  Object.keys(options).map(function (value) {

    var option    = $.extend( {}, options[value]),
        wrapper   = document.createElement('div'),
        id        = foBu.settings.uid + '__' + componentSettings.attributes.name + '--' + i,
        name      = componentSettings.attributes.name,
        labelText = option.label,
        element   = document.createElement('input'),
        label     = createRadioOrCheckboxLabel(id, labelText, foBu);

    foBu.addAttributes(element, {
      'type'  : componentSettings.elementType,
      'id'    : id,
      'name'  : name,
      'value' : value
    });

    if (selectedOption && selectedOption === value) {
      foBu.addAttributes(element, {'selected' : 'selected'});
    }

    wrapper.appendChild(element);
    wrapper.appendChild(label);
    option.id = id;
    if(!option.attributes) {
      option.attributes = {};
    }
    option.attributes.name  = name;
    option.attributes.value = value;
    option.domWrapper       = wrapper;
    option.domElement       = element;
    option.elementType      = componentSettings.elementType + 'Option';

    foBu.currentInputs.push(option);

    parentElement.appendChild(wrapper);

    i++;
  });

  return parentElement;
}

module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = document.createElement('div'),
      wrapper          = componentObject.wrapper;

  element = addRadioOrCheckboxOptions(element, componentSettings || {}, null, foBu);
  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
